/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query PartnersoverviewQuery($uid: String!) {
    prismic {
      partnersoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_PartnersoverviewBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_PartnersoverviewBodyDynamicformbuilder {
          type
          label
          primary {
            footer_form_text
            form_anchor_name
            form_post_location
            header_form_text
            marketo_form_id
            munchkin_account_id
            sub_header_form_text
            thank_you_message
            analytics_track
            analytics_action
          }
          fields {
            field_alphanumeric
            field_column_width
            field_error_message
            field_max_length
            field_name
            field_placeholder
            field_post_name
            field_required
            field_type
            field_value
            section_header
            section_sub_header
          }
        },
        ... on PRISMIC_PartnersoverviewBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Partnersoverview = ({ data, location }) =>
  data.prismic.partnersoverview ? (
    <MainLayout location={location} layout='partnersoverview'>
    <Helmet>
      <title>{(data.prismic.partnersoverview.title[0] && data.prismic.partnersoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.partnersoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.partnersoverview.path : 'https://www.digitalocean.com' + data.prismic.partnersoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.partnersoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.partnersoverview.title[0] ? data.prismic.partnersoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.partnersoverview.description ? data.prismic.partnersoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.partnersoverview.open_graph_image ? data.prismic.partnersoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.partnersoverview.description ? data.prismic.partnersoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.partnersoverview.title[0] ? data.prismic.partnersoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.partnersoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.partnersoverview.path : 'https://www.digitalocean.com' + data.prismic.partnersoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.partnersoverview.open_graph_image ? data.prismic.partnersoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.partnersoverview.body} />
    </MainLayout>
  ) : null;

Partnersoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Partnersoverview;
